import { t } from "copy/t";

// Guests reach the gallery, its password gate and the shared-photo page from a
// shared link, and those pages record page views and IP addresses, so each one
// links the privacy policy and terms (CalOPPA wants a conspicuous link
// containing "Privacy").
const LEGAL_LINKS = [
  { key: "privacy", href: "https://www.movebooth.com/privacy" },
  { key: "terms", href: "https://www.movebooth.com/terms" },
];

// Over the footer's dark gradient: white with a soft shadow, readable over a
// bright photo. On a solid background (the password gate) the caller passes a
// `color` that clears WCAG AA contrast against it.
const OVERLAY_TONE =
  "text-white decoration-white/50 hover:decoration-white [text-shadow:0_1px_2px_rgba(0,0,0,0.8)] focus-visible:outline-white";
const SOLID_TONE = "decoration-current focus-visible:outline-current";

const LegalLinks = ({ color }) => (
  <nav aria-label={t("galleryFooter.legalNavLabel")} className="flex gap-3">
    {LEGAL_LINKS.map(({ key, href }) => (
      <a
        key={key}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={color ? { color } : undefined}
        className={`text-[11px] font-headline font-medium leading-4 underline underline-offset-2 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
          color ? SOLID_TONE : OVERLAY_TONE
        }`}
      >
        {t(`galleryFooter.${key}`)}
      </a>
    ))}
  </nav>
);

export default LegalLinks;
